import { useEffect, useState } from 'react';
import { listDocumentTypes, listTruckClasses, type DocumentType, type TruckClass } from '../reference-data/reference-data.api';

export type TruckCataloguesState =
  { status: 'loading' } | { status: 'loaded'; truckClasses: TruckClass[]; documentTypes: DocumentType[] } | { status: 'error' };

/** The two catalogues the truck create/edit form and the list's class filter read — both active-only, fetched once (CLAUDE.md's small-fixed-catalogue exception to server-side paging). */
export function useTruckCatalogues(): TruckCataloguesState {
  const [state, setState] = useState<TruckCataloguesState>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;

    Promise.all([listTruckClasses(), listDocumentTypes()])
      .then(([truckClasses, documentTypes]) => {
        if (!cancelled)
          setState({
            status: 'loaded',
            truckClasses: truckClasses.filter((c) => c.isActive),
            documentTypes: documentTypes.filter((d) => d.isActive && d.appliesTo === 'truck'),
          });
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'error' });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
